import '../../sass/blocks/anchor-point.scss';

(() => {
    const $siteHeaderInnerWrapper = document.querySelector('.site-header__inner-wrapper');
    const $anchorPoints = document.querySelectorAll('.anchor-point');

    if (!$anchorPoints) return;

    $anchorPoints.forEach($anchorPoint => {
        const setTopPosition = () => {
            if (!$siteHeaderInnerWrapper) return;

            $anchorPoint.style.top = `${-$siteHeaderInnerWrapper.clientHeight}px`;
        };

        window.addEventListener('resize', setTopPosition);

        setTopPosition();
    });
})();
